import { withTransaction } from '@elastic/apm-rum-react'
import IconsEnum from '@enums/icons.enum'
import { Campaign, Tag } from '@hub/shared'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  campaign: Campaign
}

const ContentListComponent = ({ campaign }: Props) => {
  const [t] = useTranslation('campaignContentOrientation')
  const iconsEnum = useMemo(() => IconsEnum, [])

  const contentList = useMemo(() => {
    return [
      {
        id: 1,
        content: campaign?.activation?.postsCount,
        icon: iconsEnum.post,
        text: 'posts',
      },
      {
        id: 2,
        content: campaign?.activation?.storiesCount,
        icon: iconsEnum.stories,
        text: 'stories',
      },
      {
        id: 3,
        content: campaign?.activation?.reelsCount,
        icon: iconsEnum.reels,
        text: 'reels',
      },
      {
        id: 4,
        content: campaign?.activation?.tweetsCount,
        icon: iconsEnum.tweet,
        text: 'tweets',
      },
      {
        id: 5,
        content: campaign?.activation?.tweetsCount,
        icon: iconsEnum.tweet,
        text: 'tweets',
      },
      {
        id: 6,
        content: campaign?.activation?.tweetsRetweetsCount,
        icon: iconsEnum.retweet,
        text: 'tweets',
      },
      {
        id: 7,
        content: campaign?.activation?.tweetsThreadCount,
        icon: iconsEnum.tweetThread,
        text: 'tweets',
      },
      {
        id: 8,
        content: campaign?.activation?.videosCount,
        icon: iconsEnum.video,
        text: 'videos',
      },
    ]
  }, [iconsEnum, campaign?.activation])

  const hasContractedContent = useMemo(
    () =>
      !!campaign?.activation?.postsCount ||
      !!campaign?.activation?.storiesCount ||
      !!campaign?.activation?.reelsCount ||
      !!campaign?.activation?.tweetsCount ||
      !!campaign?.activation?.tweetsRetweetsCount ||
      !!campaign?.activation?.tweetsThreadCount ||
      !!campaign?.activation?.videosCount,
    [campaign?.activation]
  )

  if (!hasContractedContent) {
    return null
  }
  return (
    <div className={'mt-3'}>
      <h5>{t('campaignRules')}</h5>
      {contentList.map(
        (item) =>
          !!item.content && (
            <Tag
              className="mb-3 p-2"
              icon={<i className={`${item.icon} lg`}></i>}
              labels={[
                `${t('toDo')} ${item.text} `,
                <span className="text-bold">
                  {item.content} {t('atLeast')}
                </span>,
              ]}
              separator
              key={`${item.id}`}
            />
          )
      )}
    </div>
  )
}

export default withTransaction('ContentListComponent', 'component')(ContentListComponent)
